import React, { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { COLORS } from "../colors";
import {
  addRevenue,
  auth,
  getAllBookings,
} from "../utils/firebase/firebase.utils";
import { CSVLink } from "react-csv";

const AdminDashboard = () => {
  const currentUser = auth.currentUser;
  const navigate = useNavigate();

  const [bookings, setBookings] = useState([]);
  const [bookingsForExport, setBookingsForExport] = useState([]);
  const [allValues, setAllValues] = useState({});

  const changeHandler = (e) => {
    setAllValues((prevValues) => {
      return { ...prevValues, [e.target.name]: e.target.value };
    });
  };

  const calcAptId = (id) => {
    switch (id) {
      case "WozqnQFbfjFkBgReojcN":
        return "Nordbahnstrasse 20/7";
        break;
      case "k5urLUJGw3jYUakv22aV":
        return "Treustrasse 10/3";
        break;
      case "quY92TrNIA7WGFGzBJWW":
        return "Treustrasse 10/8";
        break;
      case "sVMVHVlyKIARpUGkPSaA":
        return "Vorgartenstraße 144";
        break;
      default:
        break;
    }
  };

  useEffect(() => {
    if (!currentUser) {
      navigate("/admin");
    } else if (currentUser.uid !== "tVQXHYIlGURh3w0wQ1jbzzjMDJq1") {
      navigate("/admin");
    }
    const getBookings = async () => {
      const books = await getAllBookings();
      books.sort((a, b) => new Date(b.arrival) - new Date(a.arrival));

      setBookings([...books]);
      const newBooks = JSON.parse(JSON.stringify(books));
      const adaptedBooks = newBooks.map((book) => {
        if (book.additionalGuests === undefined) {
          return { bookingId: book.bookingId };
        }

        const noOfGuests = book.additionalGuests.length;
        book["noOfGuests"] = noOfGuests + 1;

        const arrDate = new Date(book.arrival);
        const depDate = new Date(book.departure);
        const diffTime = Math.abs(depDate - arrDate);
        const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24));
        book["nightsStayed"] = diffDays;

        const ortst = book.ortstaxe.toString().replace(".", ",");
        book.ortstaxe = ortst;

        delete book.additionalGuests;
        delete book.signatureUrl;
        delete book.identityUrl;
        delete book.address;
        delete book.birthday;
        delete book.firstName;
        delete book.lastName;
        delete book.gender;
        delete book.nationality;
        delete book.userId;
        delete book.createdAt;
        return book;
      });
      setBookingsForExport(adaptedBooks);
    };
    getBookings();
  }, []);

  return (
    <div
      style={{
        margin: 20,
        display: "flex",
        alignItems: "center",
        flexDirection: "column",
      }}
    >
      <div style={{ display: "flex", flexDirection: "row" }}>
        <CSVLink
          style={{
            textDecoration: "none",
            position: "absolute",
            left: 20,
            top: 20,
            background: "none",
            padding: 10,
            fontWeight: "bold",
            borderRadius: 10,
            color: COLORS.tertiary,
            borderColor: COLORS.tertiary,
            borderStyle: "solid",
          }}
          data={bookingsForExport}
          filename={`bookingDataExport.csv`}
          target="_blank"
        >
          Buchungen exportieren
        </CSVLink>
        <h1>Dashboard</h1>
        <button
          style={{
            textDecoration: "none",
            position: "absolute",
            right: 20,
            top: 20,
            background: "none",
            padding: 10,
            fontWeight: "bold",
            borderRadius: 10,
            color: COLORS.darkText,
          }}
          onClick={() => {
            console.log(bookings);
            navigate("/admin/create-booking");
          }}
        >
          Neue Buchung anlegen
        </button>
      </div>
      {/* {bookings.map((booking) => {
          if (typeof booking.firstName == "undefined") {
            return (
              <div
                key={booking.bookingId}
                style={{
                  width: 500,
                  border: "1px solid black",
                  borderRadius: 20,
                  padding: 20,
                  margin: 50,
                }}
              >
                <h3 style={{ marginBottom: 20 }}>{booking.bookingId}</h3>
                <p> Noch keine Daten vorhanden </p>
                {booking.revenue ? (
                  <div
                    style={{
                      flexDirection: "row",
                      display: "flex",
                      justifyContent: "space-between",
                      marginBlock: 10,
                      width: "90%",
                    }}
                  >
                    <div style={{ flexDirection: "row", display: "flex" }}>
                      <p style={{ fontWeight: "bold", marginRight: 5 }}>
                        Einnahmen:
                      </p>
                      <p>{booking.revenue}</p>
                    </div>
                    <div style={{ flexDirection: "row", display: "flex" }}>
                      <p style={{ fontWeight: "bold", marginRight: 5 }}>
                        Ortstaxe (Ust. frei):
                      </p>
                      <p>{booking.ortstaxe}</p>
                    </div>
                  </div>
                ) : (
                  <form
                    onSubmit={async (e) => {
                      e.preventDefault();
                      if (
                        typeof allValues[`${booking.bookingId}`] ==
                          "undefined" ||
                        allValues[`${booking.bookingId}`] == ""
                      ) {
                        alert("Not valid");
                        return;
                      }
                      const res = await addRevenue(
                        booking.bookingId,
                        allValues[`${booking.bookingId}`]
                      );
                      res === 200
                        ? alert("Success")
                        : alert("Error uploading revenue");
                    }}
                  >
                    <input
                      name={booking.bookingId}
                      type="number"
                      step="0.01"
                      lang="de"
                      value={allValues[`${booking.bookingId}`]}
                      onChange={changeHandler}
                    />
                    <button type="submit">Update</button>
                  </form>
                )}
              </div>
            );
          }

          return (
            <div
              style={{
                border: "1px solid black",
                flexDirection: "column",
                borderRadius: 20,
                padding: 20,
                margin: 50,
                alignItems: "start",
                display: "flex",
              }}
              key={booking.bookingId}
            >
              <h3 style={{ marginBottom: 20 }}>{booking.bookingId}</h3>
              <div
                style={{
                  flexDirection: "row",
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  
                  marginBottom: 10,
                }}
              >
                <div style={{ flexDirection: "row", display: "flex", marginRight: "1rem" }}>
                  <p style={{ fontWeight: "bold", marginRight: 5 }}>Vorname:</p>
                  <p>{booking.firstName}</p>
                </div>
                <div style={{ flexDirection: "row", display: "flex", marginRight: "1rem" }}>
                  <p style={{ fontWeight: "bold", marginRight: 5 }}>
                    Nachname:
                  </p>
                  <p>{booking.lastName}</p>
                </div>
                <div style={{ flexDirection: "row", display: "flex", marginRight: "1rem" }}>
                  <p style={{ fontWeight: "bold", marginRight: 5 }}>
                    Geschlecht:
                  </p>
                  <p>{booking.gender}</p>
                </div>
                <div style={{ flexDirection: "row", display: "flex", marginRight: "1rem" }}>
                  <p style={{ fontWeight: "bold", marginRight: 5 }}>
                    Geburtstag:
                  </p>
                  <p>{booking.birthday}</p>
                </div>
              </div>
              <div
                style={{
                  flexDirection: "row",
                  display: "flex",
                  justifyContent: "space-between",
                  marginBlock: 10,
                }}
              >
                <div style={{ flexDirection: "row", display: "flex", marginRight: "1rem" }}>
                  <p style={{ fontWeight: "bold", marginRight: 5 }}>
                    Nationalität:
                  </p>
                  <p>{booking.nationality}</p>
                </div>
                <div style={{ flexDirection: "row", display: "flex", marginRight: "1rem" }}>
                  <p style={{ fontWeight: "bold", marginRight: 5 }}>Adresse:</p>
                  <p>{booking.address}</p>
                </div>
             
                <div style={{ flexDirection: "row", display: "flex", marginRight: "1rem" }}>
                  <p style={{ fontWeight: "bold", marginRight: 5 }}>Stadt:</p>
                  <p>{booking.city}</p>
                </div>
                <div style={{ flexDirection: "row", display: "flex", marginRight: "1rem" }}>
                  <p style={{ fontWeight: "bold", marginRight: 5 }}>PLZ:</p>
                  <p>{booking.plz}</p>
                </div>
              </div>
          
              <div
                style={{
                  flexDirection: "row",
                  display: "flex",
                  justifyContent: "space-between",
                  marginBlock: 10,
                }}
              >
                <div style={{ flexDirection: "row", display: "flex", marginRight: "1rem" }}>
                  <p style={{ fontWeight: "bold", marginRight: 5 }}>Land:</p>
                  <p>{booking.country}</p>
                </div>
                <div style={{ flexDirection: "row", display: "flex", marginRight: "1rem" }}>
                  <p style={{ fontWeight: "bold", marginRight: 5 }}>Region:</p>
                  <p>{booking.state}</p>
                </div>
                  <p
                    style={{
                      fontWeight: "bold",
                      marginRight: 5,
                      marginBottom: 10,
                    }}
                  >
                    Ankunftsdatum
                  </p>
                  <p>{booking.arrival}</p>

                  <p
                    style={{
                      fontWeight: "bold",
                      marginRight: 5,
                      marginBottom: 10,
                    }}
                  >
                    Abreisedatum
                  </p>
                  <p>{booking.departure}</p>
              </div>
           
              <div
                style={{
                  flexDirection: "row",
                  display: "flex",
                  justifyContent: "space-evenly",
                  marginBlock: 20,
                }}
              >
                <div
                  style={{
                    flexDirection: "column",
                    display: "flex",
                    flex: 1,
                    margin: 10,
                  }}
                >
                  <p style={{ fontWeight: "bold", marginRight: 5 }}>Ausweis:</p>
                  <img src={booking.identityUrl} style={{ maxWidth: "200px", aspectRatio: "16/9", objectFit: "cover", objectPosition: "center" }} />
                </div>
                <div
                  style={{
                    flexDirection: "column",
                    display: "flex",
                    flex: 1,
                    margin: 10,
                  }}
                >
                  <p style={{ fontWeight: "bold", marginRight: 5 }}>
                    Unterschrift:
                  </p>
                  <img
                    src={booking.signatureUrl}
                    style={{ maxWidth: "200px" }}
                  />
                </div>
              </div>
        
              {booking.additionalGuests.length > 0 ? (
                <div
                  style={{
                    flexDirection: "row",
                    display: "flex",
                    justifyContent: "start",
                    marginBlock: 20,
                  }}
                >
                  <p style={{ fontWeight: "bold", marginRight: 5 }}>
                    Zusätzliche Gäste:
                  </p>
                  {booking.additionalGuests.map((addGuest) => {
                    return (
                      <div>
                        <p>
                          {addGuest.firstName} {addGuest.lastName}
                        </p>
                        <p>{addGuest.birthday}</p>
                      </div>
                    );
                  })}
                </div>
              ) : null}
              {booking.revenue ? (
                <div
                  style={{
                    flexDirection: "row",
                    display: "flex",
                    justifyContent: "space-between",
                    marginBlock: 10,
                    width: "90%",
                  }}
                >
                  <div style={{ flexDirection: "row", display: "flex" }}>
                    <p style={{ fontWeight: "bold", marginRight: 5 }}>
                      Einnahmen:
                    </p>
                    <p>{booking.revenue}</p>
                  </div>
                  <div style={{ flexDirection: "row", display: "flex" }}>
                    <p style={{ fontWeight: "bold", marginRight: 5 }}>
                      Ortstaxe (Ust. frei):
                    </p>
                    <p>{booking.ortstaxe}</p>
                  </div>
                </div>
              ) : (
                <form
                  onSubmit={async (e) => {
                    e.preventDefault();
                    if (
                      typeof allValues[`${booking.bookingId}`] == "undefined" ||
                      allValues[`${booking.bookingId}`] == ""
                    ) {
                      alert("Not valid");
                      return;
                    }
                    const res = await addRevenue(
                      booking.bookingId,
                      allValues[`${booking.bookingId}`]
                    );
                    res === 200
                      ? alert("Success")
                      : alert("Error uploading revenue");
                  }}
                >
                  <input
                    placeholder="Umsatz eintragen"
                    name={booking.bookingId}
                    value={allValues[`${booking.bookingId}`]}
                    onChange={changeHandler}
                  />
                  <button type="submit">Update</button>
                </form>
              )}
            </div>
          );
        })} */}

      <div
        style={{
          overflowX: "auto",
          marginInline: "100px",
          marginTop: "50px",
          width: "100%",
        }}
      >
        <table
          style={{
            width: "100%",
            borderCollapse: "collapse",
            minWidth: "1000px",
            fontSize: "0.65rem", // radically reduced text size
          }}
        >
          <thead style={{ backgroundColor: "#f0f0f0", textAlign: "start" }}>
            <tr>
              <th style={{ textAlign: "start", paddingRight: "10px" }}>Ref</th>
              <th style={{ textAlign: "start", paddingRight: "10px" }}>
                Ortstaxe
              </th>
              <th style={{ textAlign: "start", paddingRight: "10px" }}>
                Apartment
              </th>
              <th style={{ textAlign: "start", paddingRight: "10px" }}>
                Vorname
              </th>
              <th style={{ textAlign: "start", paddingRight: "10px" }}>
                Nachname
              </th>
              <th style={{ textAlign: "start", paddingRight: "10px" }}>
                Geschlecht
              </th>
              <th style={{ textAlign: "start", paddingRight: "10px" }}>
                Geburtstag
              </th>
              <th style={{ textAlign: "start", paddingRight: "10px" }}>
                Nationalität
              </th>
              <th style={{ textAlign: "start", paddingRight: "10px" }}>
                Adresse
              </th>
              <th style={{ textAlign: "start", paddingRight: "10px" }}>
                Stadt
              </th>
              <th style={{ textAlign: "start", paddingRight: "10px" }}>PLZ</th>
              <th style={{ textAlign: "start", paddingRight: "10px" }}>Land</th>
              <th style={{ textAlign: "start", paddingRight: "10px" }}>
                Region
              </th>
              <th style={{ textAlign: "start", paddingRight: "10px" }}>
                Ankunft
              </th>
              <th style={{ textAlign: "start", paddingRight: "10px" }}>
                Abreise
              </th>
              <th style={{ textAlign: "start", paddingRight: "10px" }}>
                Einnahmen
              </th>
              <th style={{ textAlign: "start", paddingRight: "10px" }}>
                Ausweis
              </th>
              <th style={{ textAlign: "start", paddingRight: "10px" }}>
                Unterschrift
              </th>
              <th style={{ textAlign: "start", paddingRight: "10px" }}>
                Zusätzliche Gäste
              </th>
            </tr>
          </thead>
          <tbody>
            {bookings.map((booking) => (
              <tr
                key={booking.bookingId}
                style={{ borderBottom: "1px solid #ccc", height: "80px" }}
              >
                <td style={{ paddingRight: "10px" }}>{booking.bookingId}</td>
                <td style={{ fontWeight: "bold" }}>
                  € {booking.ortstaxe || "-"}
                </td>
                <td style={{ paddingRight: "10px" }}>
                  {calcAptId(booking.apartmentId) || "-"}
                </td>
                <td style={{ paddingRight: "10px" }}>
                  {booking.firstName || "-"}
                </td>
                <td style={{ paddingRight: "10px" }}>
                  {booking.lastName || "-"}
                </td>
                <td style={{ paddingRight: "10px" }}>
                  {booking.gender || "-"}
                </td>
                <td style={{ paddingRight: "10px" }}>
                  {booking.birthday || "-"}
                </td>
                <td style={{ paddingRight: "10px" }}>
                  {booking.nationality || "-"}
                </td>
                <td style={{ paddingRight: "10px" }}>
                  {booking.address || "-"}
                </td>
                <td style={{ paddingRight: "10px" }}>{booking.city || "-"}</td>
                <td style={{ paddingRight: "10px" }}>{booking.plz || "-"}</td>
                <td style={{ paddingRight: "10px" }}>
                  {booking.country || "-"}
                </td>
                <td style={{ paddingRight: "10px" }}>{booking.state || "-"}</td>
                <td style={{ paddingRight: "10px" }}>
                  {booking.arrival || "-"}
                </td>
                <td style={{ paddingRight: "10px" }}>
                  {booking.departure || "-"}
                </td>
                <td style={{ paddingRight: "10px" }}>
                  {booking.revenue || (
                    <form
                      onSubmit={async (e) => {
                        e.preventDefault();
                        if (!allValues[booking.bookingId]) {
                          alert("Not valid");
                          return;
                        }
                        const res = await addRevenue(
                          booking.bookingId,
                          allValues[booking.bookingId]
                        );
                        res === 200
                          ? alert("Success")
                          : alert("Error uploading revenue");
                      }}
                    >
                      <input
                        type="number"
                        step="0.01"
                        name={booking.bookingId}
                        value={allValues[booking.bookingId] || ""}
                        onChange={changeHandler}
                        style={{ fontSize: "0.6rem", width: "60px" }}
                      />
                      <button type="submit" style={{ fontSize: "0.6rem" }}>
                        Update
                      </button>
                    </form>
                  )}
                </td>

                <td style={{ paddingRight: "10px" }}>
                  {booking.identityUrl ? (
                    <img
                      src={booking.identityUrl}
                      alt="Ausweis"
                      style={{
                        aspectRatio: 1 / 1,
                        objectFit: "contain",
                        width: "80px",
                      }}
                    />
                  ) : (
                    "-"
                  )}
                </td>
                <td style={{ paddingRight: "10px" }}>
                  {booking.signatureUrl ? (
                    <img
                      src={booking.signatureUrl}
                      alt="Unterschrift"
                      style={{
                        aspectRatio: 1 / 1,
                        objectFit: "contain",
                        width: "80px",
                      }}
                    />
                  ) : (
                    "-"
                  )}
                </td>
                <td style={{ paddingRight: "10px" }}>
                  {booking.additionalGuests &&
                  booking.additionalGuests.length > 0
                    ? booking.additionalGuests.map((guest, i) => (
                        <div key={i}>
                          {guest.firstName} {guest.lastName} <br />
                          {guest.birthday}
                        </div>
                      ))
                    : "-"}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <button
        style={{ background: "none", borderStyle: "solid", padding: 10 }}
        onClick={async () => {
          const books = await getAllBookings();
          setBookings([...books]);
        }}
      >
        Update Bookings
      </button>
    </div>
  );
};

export default AdminDashboard;
